"use client";

import Link from "next/link";
import Image from "next/image";
import { renderButtonStyle } from "../utils/render-button-style";

export default function LangRedirect() {
  return (
    <section>
      <div>
        <div>
          <h1 className="ant-typography">
            There is no content available in your language.
          </h1>

          <div>
            <Link href="/en" className={renderButtonStyle("primary")}>
              Back To English
            </Link>
          </div>
        </div>
        <div>
          <Image
            src="https://images.pexels.com/photos/409701/pexels-photo-409701.jpeg"
            alt="PPC Blue Romania"
            className=""
            width={600}
            height={600}
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}
